import { useMemo } from 'react';

import { useJobContext } from 'pages/Job/context';
import { formatToCurrency } from 'utils';
import { getJobMinimumMonthlyPayment } from 'utils/FinanceRate-functions';

export interface FinancePaymentCardHook {
  monthly: string;
}

export default function useFinancePaymentCard(): FinancePaymentCardHook {
  const { job, allRates } = useJobContext();

  const minimumMonthlyPayment = useMemo(
    () => getJobMinimumMonthlyPayment(job, allRates),
    [job, allRates],
  );

  const monthly = useMemo(
    () => formatToCurrency(minimumMonthlyPayment),
    [minimumMonthlyPayment],
  );

  return {
    monthly,
  };
}
